import moment from 'moment';
import qs from 'qs';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { Ukrainian } from 'flatpickr/dist/l10n/uk';
import { Russian } from 'flatpickr/dist/l10n/ru';
import { sendEvent } from '../../helpers/analytics';
import './datepicker.scss';

export default (appointmentLink, opportunitiesParams, mutedDates = []) => {
  if (!appointmentLink) return;
  const locale = window.currentLanguage;
  // moment localization
  moment.locale(locale);

  // flatpickr configuration
  const datePicker = () => {
    const {
      notWorkingWeekDays,
      appointmentsUrl,
      isAvailableToday,
    } = opportunitiesParams;
    const minDate = moment();
    if (!isAvailableToday) {
      minDate.add(1, 'days');
    }

    flatpickr('#datepicker', {
      inline: true,
      locale: locale === 'uk' ? Ukrainian : Russian,
      minDate: minDate.toDate(),
      maxDate: moment().add(20, 'days').toDate(),
      disable: [
        (date) => {
          const indexOfNotWorkingDay = notWorkingWeekDays.indexOf(date.getDay());
          if (indexOfNotWorkingDay !== -1) {
            return date.getDay().toString() === notWorkingWeekDays[indexOfNotWorkingDay];
          }
          return false;
        },
        ...mutedDates,
      ],
      onChange: (selectedDates, dateStr) => {
        const searchParams = appointmentLink.href.split('?')[1];
        const stringified = qs.stringify({
          ...qs.parse(searchParams),
          date: dateStr,
        });
        sendEvent(window.eventCategory, 'sales_office', 'day_click');
        appointmentLink.href = `${appointmentsUrl}?${stringified}`;
      },
    });
  };
  
  datePicker();
};
